import { render, staticRenderFns } from "./14.vue?vue&type=template&id=06f6a2fc&scoped=true&"
import script from "./14.vue?vue&type=script&lang=js&"
export * from "./14.vue?vue&type=script&lang=js&"
import style0 from "./14.vue?vue&type=style&index=0&id=06f6a2fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f6a2fc",
  null
  
)

export default component.exports